getUserSubscriptions